import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Generator from './components/Generator';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  typography: {
    "fontFamily": `"Roboto", "Helvetica", "Arial", sans-serif`,
    "fontSize": 14
  }
});


function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      <Generator />
    </ThemeProvider>
  );
}

export default App;
